const data = {
  supported_RPT_devices: [
    'DeltaSol® AL E HE V2.00',
    'DeltaSol® BS Plus ≤ V1.02',
    'DeltaSol® BS 2 ≤ W002100',
    'DeltaSol® BS 4 ≤ W004100',
    'DeltaSol® BS Plus ≤ W005100',
    'DeltaSol® BX ≤ V2.01',
    'DeltaSol® BX V3.02',
    'DeltaSol® BX Plus V1.06',
    'DeltaSol® BX Plus V1.10',
    'DeltaSol® CS Plus ≤ V1.10',
    'DeltaSol® CS2 V1.11',
    'DeltaSol® CS4 V1.11',
    'Deltasol® MX V1.12',
    'DeltaSol® MX V2.02',
    'DeltaSol® SL ≤ V1.04',
    'DeltaSol® SLL > V1.01 ≤ V1.06',
    'DeltaSol® SLT V1.03',
    'DeltaTherm® HC ≤ V1.10',
    'DeltaTherm® HC mini = V1.0'
  ],
  supported_settings_documentation_devices: [{
    id: 'QfcHNUvmQZSTrh4r4gNytFb2ZaHOKi71YBoLNRuPFjF6OrY461j9G018pH4gn82P',
    name: 'DeltaSol®MX ≥ 2.00',
    housing: 'dsmx',
    supportedLanguages: [
      'de',
      'en',
      'fr',
      'it',
      'es',
      'fi'
    ]
  }, {
    id: 'rIeO9R3ys8p34xH5nGSu0B4THel0PhOWOiEdCQ7jDhkgPwNqho6bVpMsVK8bzgAp',
    name: 'DeltaTherm® HC MAX ≥ 2.05',
    housing: 'dsmx',
    supportedLanguages: [
      'de',
      'en',
      'fr',
      'it',
      'es',
      'fi'
    ]
  }, {
    id: 'RqOf5j9C9BjbDEXsKotCURTtJQaxHN7KuPrmeGlbTOH3VSGsK5PMZlmuVgFhjOVw',
    name: 'DeltaSol® BX Plus ≥ 2.05',
    housing: 'dsbx',
    supportedLanguages: [
      'de',
      'en',
      'fr',
      'it',
      'es',
      'fi'
    ]
  }, {
    id: 'BppsGDZhwNuA2VIIGbxYAxbl6hzNHWO1AfOLZGlTUmB4r97zu4nCLcvc2FzlH6vg',
    name: 'DeltaSol® MX Plus ≥ 1.00',
    housing: 'dsmx',
    supportedLanguages: [
      'de',
      'en',
      'fr',
      'it',
      'es',
      'fi'
    ]
  }, {
    id: 'rpiXFr7qKNVig8MY3ZNe4QaltAXiEgODgcGvBfk1TnJ66ISkyPXQc7ki2WzHIQTA',
    name: 'DeltaTherm® HC Plus ≥ 1.00',
    housing: 'dsbx',
    supportedLanguages: [
      'de',
      'en',
      'fr',
      'it',
      'es',
      'fi'
    ]
  }, {
    id: 'scVKWMiYAN8SKoNMkQmNAbbT0HklWde7jO1lv5P5cRjUlIHoaI8MRcO02vO4b50Y',
    name: 'DeltaTherm® HC mini ≥ 2.00',
    housing: 'dssl',
    supportedLanguages: [
      'de',
      'en',
      'fr',
      'it',
      'es',
      'fi'
    ]
  }],
  downloadFormats: [
    'choose.download.format',
    'visualization.downloadFormatTextTabWin',
    'visualization.downloadFormatTextSemWin',
    'visualization.downloadFormatTextTabLin',
    'visualization.downloadFormatTextSemLin',
    'visualization.downloadFormatVbus'
  ],
  periodLables: [
    'day.today',
    'day.yesterday',
    'day.lastSeven',
    'day.lastThirty',
    'day.currentMonth',
    'day.lastMonth',
    'day.lastTwo'
  ],
  defaultColors: [
    '#e6194b', // Red
    '#0082c8', // Blue
    '#ffe119', // Yellow
    '#3cb44b', // Green
    '#f58231', // Orange
    '#911eb4', // Purple
    '#46f0f0', // Cyan
    '#f032e6', // Magenta
    '#d2f53c', // Lime
    '#fabebe', // Pink
    '#008080', // Teal
    '#e6beff', // Lavender
    '#aa6e28', // Brown
    '#fffac8', // Beige
    '#800000', // Maroon
    '#aaffc3', // Mint
    '#808000', // Olive
    '#ffd8b1', // Coral
    '#000080', // Navy
    '#808080', // Grey
    '#000000' // Black
  ],
  oldDefaultColors: [
    '#FF0000', // red
    '#0000FF', // blue
    '#FFFF00', // yellow
    '#FF00FF', // magenta
    '#008000', // green
    '#FFA500', // orange
    '#87CEEB', // skyblue
    '#ADFF2F', // greenyellow
    '#FF7F50', // coral
    '#00FFFF', // cyan
    '#F0E68C', // khaki
    '#FFB6C1' // lightpink
  ],
  // Allowed Categories for Backup
  backupCategories: [
    {
      name: 'sideBar.filters',
      obj_key: 'filters',
      name_key: 'name',
      deps: [],
      icon: 'fa fa-filter'
    }, {
      name: 'default.filter.values',
      obj_key: 'default_filters',
      name_key: 'system',
      deps: [],
      icon: 'fa fa-filter'
    }, {
      name: 'sideBar.images',
      obj_key: 'images',
      name_key: 'name',
      deps: ['images_customer'],
      icon: 'fa fa-picture-o'
    }, {
      name: 'sideBar.liveSchemes',
      obj_key: 'schemes',
      name_key: 'name',
      deps: ['filters', 'images'],
      icon: 'fa-object-group'
    }, {
      name: 'sideBar.diagrams',
      obj_key: 'diagrams',
      name_key: 'description',
      deps: ['filters'],
      icon: 'fa fa-line-chart'
    }, {
      name: 'sideBar.downloads',
      obj_key: 'downloads',
      name_key: 'description',
      deps: ['filters'],
      icon: 'fa fa-download'
    }, {
      name: 'visualization.scheduledDownloads',
      obj_key: 'reports',
      name_key: 'description',
      deps: ['filters'],
      icon: 'fa fa-calendar'
    }, {
      name: 'sideBar.reports',
      obj_key: 'extended_reports',
      name_key: 'description',
      deps: ['filters'],
      icon: 'fa fa-file-text-o'
    }, {
      name: 'sideBar.notifications',
      obj_key: 'notifications',
      name_key: 'name',
      deps: [],
      icon: 'fa fa-bullhorn'
    }]
}

export default data



// WEBPACK FOOTER //
// ./src/client/lib/index.js